
import { ChargingStation } from '../types/task';

export const initialStations: ChargingStation[] = [
  {
    id: '1',
    title: 'Supercharger Station A',
    description: 'High-speed charging station in downtown area with amenities.',
    location: 'Downtown',
    address: '123 Main St',
    price: 0.45,
    pricePerKwh: 0.45,
    rating: 4.5,
    available: true,
    chargerType: 'fast',
    powerOutput: 150,
    photos: [
      'https://images.unsplash.com/photo-1647349277782-9e36cf1ab402?q=80&w=2070&auto=format&fit=crop',
      'https://images.unsplash.com/photo-1558425924-f47c46f1ddfc?q=80&w=2070&auto=format&fit=crop'
    ],
    images: [
      'https://images.unsplash.com/photo-1593941707882-a5bba14938c3?q=80&w=2072&auto=format&fit=crop',
      'https://images.unsplash.com/photo-1558425924-f47c46f1ddfc?q=80&w=2070&auto=format&fit=crop'
    ],
    amenities: ['WiFi', 'Restrooms', 'Coffee'],
    hostId: 'h1',
    hostName: 'John Doe',
    isHomeCharger: false,
    availableHours: '24/7',
    reviews: [
      {
        id: 'r1',
        stationId: '1',
        userId: 'u1',
        userName: 'John Doe',
        rating: 5,
        comment: 'Great location and fast charging!',
        createdAt: new Date('2024-02-01')
      },
      {
        id: 'r2',
        stationId: '1',
        userId: 'u2',
        userName: 'Jane Smith',
        rating: 4,
        comment: 'Very convenient but a bit pricey',
        createdAt: new Date('2024-01-28')
      }
    ],
    coordinates: {
      latitude: 37.7749,
      longitude: -122.4194
    },
    networkOperator: 'Tesla',
    plugTypes: ['CCS', 'CHAdeMO'],
    numberOfPorts: 6,
    parkingType: 'street',
    paymentTypes: ['Credit Card', 'App'],
    checkins: 120,
    status: 'operational',
    verified: true
  },
  {
    id: '2',
    title: 'Home Charger B',
    description: 'Residential charging option in a quiet neighborhood.',
    location: 'Residential Area',
    address: '456 Elm St',
    price: 0.30,
    pricePerKwh: 0.30,
    rating: 4.2,
    available: true,
    chargerType: 'standard',
    powerOutput: 50,
    photos: [
      'https://images.unsplash.com/photo-1583268426300-3747c76bb036?q=80&w=2069&auto=format&fit=crop',
      'https://images.unsplash.com/photo-1721322800607-8c38375eef04?q=80&w=2070&auto=format&fit=crop'
    ],
    images: [
      'https://images.unsplash.com/photo-1583268426300-3747c76bb036?q=80&w=2069&auto=format&fit=crop',
      'https://images.unsplash.com/photo-1721322800607-8c38375eef04?q=80&w=2070&auto=format&fit=crop'
    ],
    amenities: ['Restrooms'],
    hostId: 'h2',
    hostName: 'Alice Johnson',
    isHomeCharger: true,
    availableHours: '6 PM - 8 AM',
    reviews: [
      {
        id: 'r3',
        stationId: '2',
        userId: 'u3',
        userName: 'Bob Williams',
        rating: 3,
        comment: 'Good for overnight charging',
        createdAt: new Date('2024-02-05')
      }
    ],
    coordinates: {
      latitude: 37.7952,
      longitude: -122.3936
    },
    networkOperator: 'Private',
    plugTypes: ['Type 2'],
    numberOfPorts: 1,
    parkingType: 'private',
    paymentTypes: ['Cash', 'App'],
    checkins: 30,
    status: 'operational',
    verified: false
  }
];
